import React, { PureComponent } from "react";
import {
  LoginPageWrapper,
  Logo,
  Content,
  Layer,
  LoginCard,
  FooterWrapper,
  LinkWrapper
} from "./styled";
import Footer from "../../footer/Footer";
import { MAIN_PATH } from "../../../AppRoutes";

type ChangePasswordSuccessProps = {
  history: any;
  requestLogout: () => any;
};
export default class ChangePasswordSuccess extends PureComponent<
  ChangePasswordSuccessProps
> {
  componentDidMount(): void {
    this.props.requestLogout();
  }

  render() {
    const { history } = this.props;
    return (
      <LoginPageWrapper>
        <Logo>
          <img src="/mps-logo.png" width="350" alt="Morgan Project Services" />
        </Logo>
        <Content>
          <Layer>
            <LoginCard>
              <div
                style={{
                  color: "#fff",
                  padding: "1rem 1rem 3rem 1rem",
                  textAlign: "center",
                  width: "100%"
                }}
              >
                Your password has been changed. You can now log in.
              </div>
              <LinkWrapper onClick={() => history.push(MAIN_PATH)}>
                Back To Login
              </LinkWrapper>
            </LoginCard>
          </Layer>
        </Content>
        <FooterWrapper>
          <Footer />
        </FooterWrapper>
      </LoginPageWrapper>
    );
  }
}
